import { Component } from "react";

import { trackEvent, EventNames } from 'utils/mixpanel';
import { Button, Spinner } from 'react-bootstrap';
import { ASSISTANT_RESPONSE } from "utils/constants";
import { generic_post_api } from "api/generic_api";

const formatPhone = (phoneNumber) => {

    if (!phoneNumber) { return ""; }

    if (phoneNumber.length === 10) {
        return phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3, 6) + '-' + phoneNumber.substring(6, 10);
    }

    if (phoneNumber.length === 11) {
        return phoneNumber.substring(0, 1) + '-' + phoneNumber.substring(1, 4) + '-' + phoneNumber.substring(4, 7) + '-' + phoneNumber.substring(7, 11);
    }
}

const QuickAnswerOptions = {
    response_1: 'response_1',
    response_2: 'response_2',
    custom: 'custom',
}

const QuickAnswers = {
    response_1: 'Hi, I have reviewed your request and will call you shortly.',
    response_2: `Hi, We have reviewed your request but unfortunately, we are over-extended with existing projects at the moment. 
    We are not able to take your project at this time. Thank you for reaching out and we hope to work with you in the future.`,
}

class Assistant extends Component {
    constructor(props) {
        let from_number = null;
        let idx = null;

        let urlParams = new URLSearchParams(window.location.search);
        from_number = urlParams.get('from_number');
        idx = urlParams.get('idx');

        super(props);
        this.state = {
            from_number: from_number,
            idx: idx,
            message: "",
            custom_message: "",
            complete: false,
            submitting: false,
            current_quick_response: null,
        };

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, {'data_1': 'contact_index'});
        document.title = "Respond to your request";
    }

    submit()
    {   
        this.setState({submitting: true});
        let message = "";

        if (this.state.message) {
            message = this.state.message;
        }
        else {
            message = this.state.custom_message;
        }

        let request = {
            idx: this.state.idx,
            from_number: this.state.from_number,
            message: message,
        }

        generic_post_api(request, ASSISTANT_RESPONSE)
        .then(
            (result) => {
                if (result.status === 200) { 
                    this.setState({
                        complete: true,
                        submitting: false,
                    });
                }
            }
        ).catch(error => {
            this.setState({
                submitting: false,
            });
        });
    }

    render() {
        const {from_number, message, complete, custom_message, submitting, current_quick_response} = this.state;
        
        const setMessage = (message_type, value) => {
            
            if (message_type === 'call' && value) {
                this.setState({
                    message: QuickAnswers.response_1,
                    current_quick_response: QuickAnswerOptions.response_1,
                    custom_message: "",
                });
            }
            else if (message_type === 'pass' && value) {
                this.setState({
                    message: QuickAnswers.response_2,
                    current_quick_response: QuickAnswerOptions.response_2,
                    custom_message: "",
                });
            }
            else if (message_type === 'custom' && value) {
                this.setState({
                    current_quick_response: QuickAnswerOptions.custom,
                    message: "",
                    custom_message: "",
                });
            }
        }

        const canSubmit = () => {
            return message.length > 0 || custom_message.length > 0;
        }

        return(
                <>
                { !complete ? 
                        <div class="container mt-5">
                            <div class="row">
                                <div class="col fw-bold">Respond to {formatPhone(from_number)}</div>
                            </div>
                            <div class="row mt-4">
                                <div class="col">Pick from a quick response or type your own response</div>
                            </div>
                            <div class="mt-4 row">
                                <div class='col-auto pe-0'> 
                                    <input 
                                        class="form-check-input" 
                                        type="radio" 
                                        name="radioDefault" 
                                        id="radioDefault1"
                                        checked={current_quick_response === QuickAnswerOptions.response_1}
                                        onChange={ (e) => setMessage('call', e.currentTarget.checked) }
                                    />
                                </div>
                                <div class='col'>{QuickAnswers.response_1}</div>
            
                            </div>
                            <div class="row mt-4">
                                <div class='col-auto pe-0'> 
                                    <input 
                                        class="form-check-input" 
                                        type="radio" 
                                        name="radioDefault" 
                                        id="radioDefault2"
                                        checked={current_quick_response === QuickAnswerOptions.response_2}
                                        onChange={ (e) => setMessage('pass', e.currentTarget.checked) }
                                    />
                                </div>
                                <div class='col'>{QuickAnswers.response_2}</div>
                                
                            </div>
                            <div class="row mt-4">
                                <div class='col-auto pe-0'> 
                                    <input 
                                        class="form-check-input" 
                                        type="radio" 
                                        name="radioDefault" 
                                        id="radioDefault2"
                                        checked={current_quick_response === QuickAnswerOptions.custom}
                                        onChange={ (e) => setMessage('custom', e.currentTarget.checked) }
                                    />
                                </div>
                                <div class='col'> Type your own message:</div>
                            </div>
                            <div class="row mt-1">
                                <div class='col'>
                                    <textarea 
                                        class="form-control mt-1" 
                                        rows="4" 
                                        value={custom_message} 
                                        placeholder="Type your own response here" 
                                        style={{'font-size': '15px' }} 
                                        onChange={(e) => this.setState({custom_message: e.target.value})}
                                        disabled={current_quick_response !== QuickAnswerOptions.custom}
                                    /> 
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col text-center">
                                    {
                                        submitting ? 
                                            <Button variant="primary" disabled>
                                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                Submitting ...
                                            </Button>
                                        :
                                            <Button variant="primary" onClick={this.submit} disabled={!canSubmit()}>Submit response <i class="fa-regular fa-paper-plane"></i></Button>
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    :
                    <div class="container mt-5">
                        <div class="row">
                            <div class="col fw-bold">Your response to the client was sent.</div>
                        </div>
                    </div>
                }
               </>
        )
    }
}

export default Assistant;